import { useEffect, useState } from 'react';

// local plant-protection / fertiliser database (shared with the team package)
const KEY = 'giss_agents';
export const getAgents = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
export const saveAgents = (list) => { localStorage.setItem(KEY, JSON.stringify(list)); window.dispatchEvent(new Event('giss-agents')); };
export const mergeAgents = (inc = [], replace = false) => {
  if (replace) return saveAgents(inc);
  const cur = getAgents(), ids = new Set(inc.map((a) => a.id));
  saveAgents([...cur.filter((a) => !ids.has(a.id)), ...inc]);
};
export function useAgents() {
  const [l, setL] = useState(getAgents);
  useEffect(() => { const on = () => setL(getAgents()); window.addEventListener('giss-agents', on); return () => window.removeEventListener('giss-agents', on); }, []);
  return l;
}

const DAY = 864e5;
const num = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : null; };
// waiting period per plot: red until end-2 days, yellow last 2 days, green = harvest free
export function waitState(tracks, plotId, now = Date.now()) {
  let end = null, agent = '';
  (tracks || []).forEach((tr) => {
    const m = tr.meta || {}, w = num(m.wait);
    if (tr.profile !== 'agSpray' || m.plot !== plotId || !w) return;
    const e = (tr.end || tr.start) + w * DAY;
    if (!end || e > end) { end = e; agent = m.agent || ''; }
  });
  if (!end) return null;
  const left = (end - now) / DAY;
  return { end, agent, left: Math.ceil(left), st: left <= 0 ? 'green' : left <= 2 ? 'yellow' : 'red' };
}
export const WAIT_CLR = { red: '#dc2626', yellow: '#ca8a04', green: '#16a34a' };
